var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 12.533H2.132v-1.066h1.066v1.066zm1.066 0v-1.066h5.646L7.089 8.644l.754-.755 4.11 4.11-4.11 4.111-.754-.754 2.823-2.823H4.266z",
    fill: "#170F4F"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAxNiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgIGQ9Ik0zLjE5OTQ4IDEyLjUzMzJMMi4xMzI4MSAxMi41MzMyTDIuMTMyODEgMTEuNDY2NkwzLjE5OTQ4IDExLjQ2NjZMMy4xOTk0OCAxMi41MzMyWk00LjI2NjE1IDEyLjUzMzJMNC4yNjYxNSAxMS40NjY2TDkuOTExOSAxMS40NjY2TDcuMDg5MDIgOC42NDM2OEw3Ljg0MzI3IDcuODg5NDRMMTEuOTUzNyAxMS45OTk5TDcuODQzMjcgMTYuMTEwNEw3LjA4OTAyIDE1LjM1NjFMOS45MTE5IDEyLjUzMzJMNC4yNjYxNSAxMi41MzMyWiIKICAgIGZpbGw9IiMxNzBGNEYiIC8+Cjwvc3ZnPg==";
export { SvgIconArrowRight as ReactComponent };